import { createSlice } from '@reduxjs/toolkit';

import { addDispatchableSkuBox, addGatePassBoxItem, confirmGatePassDetails, deleteGatePassBoxItem, getAllGatePassBoxDetails, getGatePassConfig, getGatePassBoxDetails, getGatePassDetails, getAllGatePasses, getNonDispatchedItemsDetails, updateGatePass, updateNonDispatchableItem, getGatePassSummary, submitGatepass, updateDispatchableSkuBox, gatePassReceiveItem, gatePassReceiveBox, completeGatePass, printBarcodeLabels } from '../../apis';
import { removeBox, reopenGatepass } from './api';

export const SourceBulkInventorySlice = createSlice({

    name: 'sourceBulkInventorySlice',
    initialState: {
        isLoading: false,
        allGatePassesData: [],
        updateGatePassData: {},
        gatePassDetailsData : {},
        configData: [],
        confirmGatePassSuccessData: {},
        addDispatchableBox: {},
        updateDispatchableBox: {},
        allBoxDetails: {},
        singleBoxDetail: {},
        addItemToBoxData: {},
        deleteItemToBoxData: {},
        nonDispatchedItemsDetails: [],
        updateNonDispatchableItemData: {},
        gatepassSummaryData: {},
        submitGatepassSuccess: false,
        removeDispatchableBox: {},
        reopenGatepassSuccessMessage: '',

        // destination
        gatePassReceiveItemData: {},
        gatePassReceiveBoxData: {},
        completeGatePassData: {},

        //print barcode
        printBarcodeLabelSuccess: false,
        error: ''
    },

    reducers: {
      clearGatePassDetailsData: (state, action) => {
        return {
          ...state,
          gatePassDetailsData: action.payload
        }
      },
      clear: (state, action) => {
        if(action?.payload?.key) {
          return {
            ...state,
            [action.payload.key]: action.payload.value
          }
        }
        return { ...state }
      },
      clearErrorState: (state, action) => {
        return {
          ...state,
          error: action.payload
        }
      }
    },

    extraReducers: (builder) => {
      builder.addCase(getAllGatePasses.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(getAllGatePasses.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.allGatePassesData = action.payload.data?.data
      })
      builder.addCase(getAllGatePasses.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(getGatePassDetails.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(getGatePassDetails.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.gatePassDetailsData = action.payload.data?.data
      })
      builder.addCase(getGatePassDetails.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(getGatePassConfig.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(getGatePassConfig.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.configData = action.payload.data?.data ?? []
      })
      builder.addCase(getGatePassConfig.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(confirmGatePassDetails.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(confirmGatePassDetails.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.confirmGatePassSuccessData = action.payload.data?.data
      })
      builder.addCase(confirmGatePassDetails.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(addDispatchableSkuBox.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(addDispatchableSkuBox.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.addDispatchableBox = action.payload?.data?.data
      })
      builder.addCase(addDispatchableSkuBox.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(updateDispatchableSkuBox.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(updateDispatchableSkuBox.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.updateDispatchableBox = action.payload?.data?.data
      })
      builder.addCase(updateDispatchableSkuBox.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      
      builder.addCase(getAllGatePassBoxDetails.pending, (state, action) => {
        state.isLoading = true;
      })
      builder.addCase(getAllGatePassBoxDetails.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.allBoxDetails = action.payload?.data?.data
      })
      builder.addCase(getAllGatePassBoxDetails.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(getGatePassBoxDetails.pending, (state, action) => {
        state.isLoading = true;
      })
      builder.addCase(getGatePassBoxDetails.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.singleBoxDetail = action.payload?.data?.data
      })
      builder.addCase(getGatePassBoxDetails.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(addGatePassBoxItem.pending, (state, action) => {
        state.isLoading = true;
      })
      builder.addCase(addGatePassBoxItem.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.addItemToBoxData = action.payload?.data?.data
      })
      builder.addCase(addGatePassBoxItem.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(deleteGatePassBoxItem.pending, (state, action) => {
        state.isLoading = true;
      })
      builder.addCase(deleteGatePassBoxItem.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.deleteItemToBoxData = action.payload?.data?.data
      })
      builder.addCase(deleteGatePassBoxItem.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(getNonDispatchedItemsDetails.pending, (state, action) => {
        state.isLoading = true;
      })
      builder.addCase(getNonDispatchedItemsDetails.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.nonDispatchedItemsDetails = action.payload?.data?.data
      })
      builder.addCase(getNonDispatchedItemsDetails.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(updateNonDispatchableItem.pending, (state, action) => {
        state.isLoading = true;
      })
      builder.addCase(updateNonDispatchableItem.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.updateNonDispatchableItemData = action.payload?.data?.data
      })
      builder.addCase(updateNonDispatchableItem.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(updateGatePass.pending, (state, action) => {
        state.isLoading = true;
      })
      builder.addCase(updateGatePass.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.updateGatePassData = action.payload?.data?.data
      })
      builder.addCase(updateGatePass.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(getGatePassSummary.pending, (state, action) => {
        state.isLoading = true;
      })
      builder.addCase(getGatePassSummary.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.gatepassSummaryData = action.payload?.data?.data
      })
      builder.addCase(getGatePassSummary.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(submitGatepass.pending, (state, action) => {
        state.isLoading = true;
      })
      builder.addCase(submitGatepass.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.submitGatepassSuccess = true
      })
      builder.addCase(submitGatepass.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(removeBox.pending, (state, action) => {
        state.isLoading = true;
      })
      builder.addCase(removeBox.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.removeDispatchableBox = action.payload?.data?.data
      })
      builder.addCase(removeBox.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      
      //destination apis
      builder.addCase(gatePassReceiveItem.pending, (state, action) => {
        state.isLoading = true;
      })
      builder.addCase(gatePassReceiveItem.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.gatePassReceiveItemData = action.payload?.data?.data
      })
      builder.addCase(gatePassReceiveItem.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(gatePassReceiveBox.pending, (state, action) => {
        state.isLoading = true;
      })
      builder.addCase(gatePassReceiveBox.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.gatePassReceiveBoxData = action.payload?.data?.data
      })
      builder.addCase(gatePassReceiveBox.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(completeGatePass.pending, (state, action) => {
        state.isLoading = true;
      })
      builder.addCase(completeGatePass.fulfilled, (state, action) => {
          state.isLoading = false;
          state.error = '';
          state.completeGatePassData = action.payload?.data?.data
      })
      builder.addCase(completeGatePass.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(printBarcodeLabels.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(printBarcodeLabels.fulfilled, (state, action) => {
          state.error = ''
          state.isLoading = false;
          state.printBarcodeLabelSuccess = true
      })
      builder.addCase(printBarcodeLabels.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
      builder.addCase(reopenGatepass.pending, (state, action) => {
          state.isLoading = true;
      })
      builder.addCase(reopenGatepass.fulfilled, (state, action) => {
          state.error = ''
          state.isLoading = false;
          state.reopenGatepassSuccessMessage = action.payload?.data?.message ?? 'Success '
      })
      builder.addCase(reopenGatepass.rejected, (state, action) => {
          state.error = action.payload.message
          state.isLoading = false;
      })
    }
})

export const { clearGatePassDetailsData, clearErrorState, clear } = SourceBulkInventorySlice.actions


export default SourceBulkInventorySlice.reducer